import React from 'react';
import { Redirect } from 'react-router-dom';
import { usePageData } from '../../_metronic/layout/core';
import { PAGE_PERMISSION } from '../modules/roles/constant/role-default';
import { ReportDetail } from '../modules/roles/models/role-model';

const ActivePageBasedRedirect = () => {
  const { currentUser: { activePages } } = usePageData();

  if (!activePages) {
    return null;
  }

  const permissionsOrder = [
    { permission: PAGE_PERMISSION.Dashboard, route: '/dashboard' },
    { permission: PAGE_PERMISSION.Faulted_Assets, route: '/faulted-assets' },
    // { permission: PAGE_PERMISSION.Service_Tickets, route: '/service-tickets' },
    { permission: PAGE_PERMISSION.Reports, route: '/reports' },
    { permission: PAGE_PERMISSION.Admin_Users, route: '/user' },
    { permission: PAGE_PERMISSION.Admin_Groups, route: '/groups' },
    { permission: PAGE_PERMISSION.Admin_Roles, route: '/role' },
    // { permission: PAGE_PERMISSION.Admin_Settings, route: '/settings' },
    // { permission: PAGE_PERMISSION.Admin_Charts, route: '/charts' },
    // { permission: PAGE_PERMISSION.Admin_Audit, route: '/audit' }
  ];

  for (let { permission, route } of permissionsOrder) {
    if (activePages.some(page => page.name === permission)) {
      return <Redirect to={route} />;
    }
  }

  return null;

};

export default ActivePageBasedRedirect;
